(() => {
  class ImageGalleryCarousel {
    constructor(carousel) {
      this.carousel = carousel;
      this.track = carousel.querySelector('.gallery-carousel__track');
      this.viewport = carousel.querySelector('.gallery-carousel__track-wrapper');
      this.slides = Array.from(carousel.querySelectorAll('[data-gallery-slide]'));
      this.previousButton = carousel.querySelector('[data-gallery-previous]');
      this.nextButton = carousel.querySelector('[data-gallery-next]');
      this.dotsContainer = carousel.querySelector('[data-gallery-dots]');
      this.currentIndex = 0;
      this.pointerStartX = null;
      this.pointerStartY = null;

      if (!this.track || !this.viewport || this.slides.length === 0) return;

      this.createDots();
      this.bindEvents();
      this.update();

      if (this.slides.length < 2) {
        this.previousButton?.classList.add('gallery-carousel__controls-hidden');
        this.nextButton?.classList.add('gallery-carousel__controls-hidden');
        this.dotsContainer?.classList.add('gallery-carousel__controls-hidden');
      }
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.replaceChildren();
      this.dots = this.slides.map((slide, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'gallery-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Show image ${index + 1}`);
        dot.addEventListener('click', () => this.goTo(index));
        this.dotsContainer.appendChild(dot);
        return dot;
      });
    }

    bindEvents() {
      this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
      this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

      this.carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.currentIndex - 1);
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.currentIndex + 1);
        }
      });

      this.viewport.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary) return;
        this.pointerStartX = event.clientX;
        this.pointerStartY = event.clientY;
      });

      this.viewport.addEventListener('pointerup', (event) => {
        if (this.pointerStartX === null || this.pointerStartY === null) return;

        const distanceX = event.clientX - this.pointerStartX;
        const distanceY = event.clientY - this.pointerStartY;
        this.pointerStartX = null;
        this.pointerStartY = null;

        if (Math.abs(distanceX) < 45 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        this.goTo(distanceX < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      });

      this.viewport.addEventListener('pointercancel', () => {
        this.pointerStartX = null;
        this.pointerStartY = null;
      });
    }

    goTo(index) {
      const slideCount = this.slides.length;
      this.currentIndex = (index + slideCount) % slideCount;
      this.update();
    }

    update() {
      this.track.style.transform = `translate3d(-${this.currentIndex * 100}%, 0, 0)`;

      this.slides.forEach((slide, index) => {
        slide.setAttribute('aria-hidden', index === this.currentIndex ? 'false' : 'true');
      });

      this.dots?.forEach((dot, index) => {
        dot.setAttribute('aria-selected', index === this.currentIndex ? 'true' : 'false');
        dot.tabIndex = index === this.currentIndex ? 0 : -1;
      });
    }
  }

  const initialiseCarousels = (container = document) => {
    container.querySelectorAll('[data-gallery-carousel]').forEach((carousel) => {
      if (carousel.dataset.galleryInitialised === 'true') return;
      carousel.dataset.galleryInitialised = 'true';
      carousel.imageGalleryCarousel = new ImageGalleryCarousel(carousel);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseCarousels());
  } else {
    initialiseCarousels();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialiseCarousels(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-gallery-slide]');
    const carousel = slide?.closest('[data-gallery-carousel]');
    if (!slide || !carousel?.imageGalleryCarousel) return;

    const index = carousel.imageGalleryCarousel.slides.indexOf(slide);
    if (index >= 0) carousel.imageGalleryCarousel.goTo(index);
  });
})();